"use strict";import{defineElement as e}from"@spectrum-web-components/base/src/define-element.js";import{Tabs as a}from"./src/Tabs.js";e("sp-tabs",a);
//# sourceMappingURL=sp-tabs.js.map
